export const styles = {
  fixedTable: {
    tableLayout: 'fixed',
  },
  searchActionButton: {
    px: 2,
    py: 0.5,
  },
};
